module.exports = __webpack_public_path__ + "static/media/choithramsDairyMilkL.88dda02a.png";